module.exports = __webpack_public_path__ + "static/life-style-large-e1a7115842907334574ac88151b6ee19.png";